import { BreastSizeOptionsType } from './types';

export const BREAST_SIZE_OPTIONS: BreastSizeOptionsType = [
  {
    id: 'small',
    title: 'Small',
  },
  {
    id: 'medium',
    title: 'Medium',
  },
  {
    id: 'large',
    title: 'Large',
  },
  {
    id: 'huge',
    title: 'Huge',
  },
];
